import { ClauseResponse } from '@/components/AttorneyRegistration/Component/Models/ClauseResponse';
import { ClausesGroup } from '@/components/AttorneyRegistration/Component/Models/ClausesGroup';
import { ConflictClause } from '@/components/AttorneyRegistration/Component/Models/ConflictClause';
import { Datasource } from '@/components/AttorneyRegistration/Component/Models/Datasource';
import { VuexModule, Mutation, Module, Action } from 'vuex-module-decorators';

@Module({})
export default class DataValuesStore extends VuexModule {
  allDataSources: Datasource[] = [];
  confilcts: ConflictClause[] = [];

  clausesGroups: ClausesGroup[] = [];
  staticClauses: ClauseResponse[] = [];

  //   selectedClauses: ClauseResponse[] = [];

  get getDataSource(): Datasource[] {
    return this.allDataSources;
  }

  get getClausesGroups(): ClausesGroup[] {
    return this.clausesGroups;
  }

  get getStaticClauses(): ClauseResponse[] {
    return this.staticClauses;
  }

  get getConfilcts(): ConflictClause[] {
    return this.confilcts;
  }

  //   get getSelectedClauses(): ClauseResponse[] {
  //     return this.selectedClauses;
  //   }

  @Mutation
  public setallDataSourcesMut(dataSources: Datasource[]): void {
    this.allDataSources = dataSources;
  }
  @Action
  public updateDataSource(dataSourcesLst: Datasource[]): void {
    this.context.commit('setallDataSourcesMut', dataSourcesLst);
  }

  @Mutation
  public setClausesGroupsMut(clausesGroups: ClausesGroup[]): void {
    this.clausesGroups = clausesGroups;
  }
  @Action
  public setClausesGroups(clausesGroups: ClausesGroup[]): void {
    this.context.commit('setClausesGroupsMut', clausesGroups);
  }

  @Mutation
  public setStaticClausesMut(staticClaues: ClauseResponse[]): void {
    this.staticClauses = staticClaues;
  }
  @Action
  public setStaticClauses(staticClaues: ClauseResponse[]): void {
    this.context.commit('setStaticClausesMut', staticClaues);
  }

  @Mutation
  public pushConflictMut(confilict: ConflictClause) {
    this.confilcts.push(confilict);
  }
  @Action
  public pushConfilict(confilict: ConflictClause) {
    this.context.commit('pushConflictMut', confilict);
  }

  //   @Mutation
  //   public setSelectedClauseMut(selcted: ClauseResponse) {
  //     this.selectedClauses.push(selcted);
  //   }
  //   @Action
  //   public setSelectedClauseAction(selected: ClauseResponse) {
  //     let found = this.selectedClauses.filter((c) => c.id == selected.id);
  //     if (found && found.length <= 0) {
  //       this.context.commit('setSelectedClauseMut', selected);
  //     }
  //   }
}
// export default UserStore;
